import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { PageWrapper } from '@/Shared/ui/layout'
import { navigationRoutes } from '@/Shared/ui/routers'
import { createApiTransactionRepository } from '@/Transactions/infrastructure'
import { TransactionProvider } from '@/Transactions/ui/context/TransactionsContext'
import { TransactionsList } from '@/Transactions/ui/organisms'
import { useUserData } from '@/User/ui/context'

import { transactionsTranslation } from '../transactionsTranslation'

export const TransactionsPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={navigationRoutes.transactions}
    >
      <TransactionProvider repository={createApiTransactionRepository()} itemsPerPage={8}>
        <PageWrapper
          paddingSmaller
          paddingTop={8}
          style={{
            paddingRight: 40,
            paddingLeft: 40,
            minWidth: '-webkit-fill-available',
            marginRight: 0,
            marginLeft: 0,
          }}
        >
          <OreHeading as="h1" size="title-sm">
            {t(transactionsTranslation.title)}
          </OreHeading>
          <OreDivider space="larger-bottom" />
          <OreStack space="xlarge" placeContent="stretch">
            {merchant.isNursery && (
              <OreText>{t(transactionsTranslation.guarderia.desc)}</OreText>
            )}
            <TransactionsList />
          </OreStack>
        </PageWrapper>
      </TransactionProvider>
    </AccountProvider>
  )
}
